import { useEffect } from 'react';
import { Outlet, useMatch, useNavigate } from 'react-router-dom';
import { PermissionEnum, PermissionDenied, IconLoader, Tabs } from '@ui/src';
import { useAppSelector } from '@store';
import ROUTES from '../../routes';

import cn from './styles.module.css';

const ExternalAccounts = (): React.JSX.Element => {
  const { activePermissions } = useAppSelector((state) => state.root);
  const { openPayNotificationVisible } = useAppSelector(
    (state) => state.externalAccounts,
  );

  const match = useMatch(ROUTES.EXTERNAL_ACCOUNTS);

  const navigate = useNavigate();

  useEffect(() => {
    if (match) {
      if (
        activePermissions?.includes(PermissionEnum.PSP_INTEGRATION_ACCOUNT_LIST)
      ) {
        navigate(ROUTES.EXTERNAL_ACCOUNTS_LIST);
      } else if (
        activePermissions?.includes(
          PermissionEnum.EXTERNAL_ORGANIZATIONS_LIST,
        ) &&
        !activePermissions?.includes(
          PermissionEnum.PSP_INTEGRATION_ACCOUNT_LIST,
        )
      ) {
        navigate(ROUTES.EXTERNAL_ACCOUNTS_LINKED_CLIENTS);
      }
    }
  }, [activePermissions, match]);

  useEffect(() => {
    let title = 'External Integrations';

    const companyName = localStorage.getItem('companyName');

    if (companyName) {
      title = `${title} | ${companyName}`;
    }

    document.title = title;
  }, []);

  let content = <div />;

  if (
    activePermissions &&
    !activePermissions?.includes(PermissionEnum.PSP_INTEGRATION_ACCOUNT_LIST) &&
    !activePermissions.includes(PermissionEnum.EXTERNAL_ORGANIZATIONS_LIST)
  ) {
    content = <PermissionDenied />;
  } else if (
    activePermissions &&
    (activePermissions?.includes(PermissionEnum.PSP_INTEGRATION_ACCOUNT_LIST) ||
      activePermissions.includes(PermissionEnum.EXTERNAL_ORGANIZATIONS_LIST))
  ) {
    content = (
      <div className={cn.external}>
        <div className={cn.externalWrapperTitle}>External integrations</div>
        {activePermissions?.includes(
          PermissionEnum.PSP_INTEGRATION_ACCOUNT_LIST,
        ) &&
          activePermissions.includes(
            PermissionEnum.EXTERNAL_ORGANIZATIONS_LIST,
          ) && (
            <Tabs
              wrapperClassName={cn.externalAccountsTabs}
              tabs={[
                {
                  name: 'Accounts',
                  path: ROUTES.EXTERNAL_ACCOUNTS_LIST,
                },
                {
                  name: 'Linked Customers',
                  path: ROUTES.EXTERNAL_ACCOUNTS_LINKED_CLIENTS,
                },
              ]}
              enableRouting
            />
          )}
        <Outlet />
        {openPayNotificationVisible && (
          <div className={cn.reportNotification}>
            <div className={cn.reportNotificationLeft}>
              <IconLoader />
              <div className={cn.reportText}>Account will be created soon</div>
            </div>
          </div>
        )}
      </div>
    );
  }

  return content;
};

export default ExternalAccounts;
